import { boot } from "quasar/wrappers"
import messages from "src/i18n"
import { createI18n } from "vue-i18n"

const i18n = createI18n({
  locale: "en-US",
  legacy: false,
  messages,
  warnHtmlMessage: false, // As long as we don't use translation on user input, we would be safe
})

export default boot(({ app }) => {
  // Set i18n instance on app
  app.use(i18n)
})

export { i18n }
